import { Link } from 'react-router-dom'
import { Box, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FaChevronRight } from 'react-icons/fa'
import { colors } from '../../../utilities/colors'
import StatusBadge from '../shared/StatusBadge'

export default function QuoteRow({ quote }) {
  const { t } = useTranslation()
  const details = quote.attributes['response-cache']
  const createdAt = quote.attributes['created-at']
  const valid = details?.status === 'active'
  const expiryDate = details?.expires_at
    ? new Date(details.expires_at).toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' })
    : null
  const vehicles = details?.vehicles || []
  const quoteLabel = vehicles.length === 1
    ? `${vehicles[0].year} ${vehicles[0].make} ${vehicles[0].model}`
    : `${vehicles.length} ${t('Vehicles')}`

  return (
    <Link to={`/transportation/quotes/${quote.attributes.id}`}>
      <Box
        display="flex"
        alignItems="center"
        py={3}
        px={2}
        borderBottom="1px solid"
        borderColor={colors.grey700}
        _hover={{ bg: colors.grey700 }}
        cursor="pointer"
        transition="background 0.15s"
      >
        <Box display="flex" flexDirection="column" gap={1} flex={1} minWidth={0}>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize="sm" fontWeight="bold" color={colors.grey100} flex={1} minWidth={0} truncate>
              {`${createdAt} · ${quoteLabel}`}
            </Text>
            <Box flexShrink={0}>
              <StatusBadge label={valid ? t('Valid') : t('Expired')} color={valid ? colors.green : colors.fpxRed} />
            </Box>
          </Box>
          <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
            <Text fontSize="xs" color={colors.grey300} flexShrink={0}>{t('Created by')}</Text>
            <Text fontSize="xs" color={colors.grey300} minWidth={0} truncate>
              {quote.attributes['created-by']}
            </Text>
          </Box>
          {expiryDate && (
            <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
              <Text fontSize="xs" color={colors.grey300} flexShrink={0}>{t('Expires')}</Text>
              <Text fontSize="xs" color={valid ? colors.grey300 : colors.fpxRed} flexShrink={0}>{expiryDate}</Text>
            </Box>
          )}
        </Box>
        <Box ml={3} color={colors.grey500}>
          <FaChevronRight size={12} />
        </Box>
      </Box>
    </Link>
  )
}
